import { ConditionSetSchema } from '@common/flare-data/schemas/condition-set-schema';
import { TargetSchema } from '@common/flare-data/schemas/target-schema';
//disable-toc:import { TocSchema } from '@common/flare-data/schemas/toc-schema';
import { VariableSetSchema } from '@common/flare-data/schemas/variable-set-schema';
import { FlareSchema } from '@common/flare/flare-schema';
import { ProjectFileType } from '@common/project-files/enums/project-file-type.enum';
import { getFileType } from '@common/project-files/util/files';
import { CollabSchema } from '@common/prosemirror/model/collab-schema';

const flare = new FlareSchema();
const variableSet = new VariableSetSchema();
const conditionSet = new ConditionSetSchema();
const target = new TargetSchema();
//disable-toc:const toc = new TocSchema();

export const FlareSchemaName = 'flare';

export function getSchemaByName(schemaName: string): CollabSchema | undefined {
  switch (schemaName) {
    case flare.name: return flare;
    case variableSet.name: return variableSet;
    case conditionSet.name: return conditionSet;
    case target.name: return target;
    //disable-toc:case toc.name: return toc;
  }
}

export function getSchemaByFileType(fileType: ProjectFileType): CollabSchema | undefined {
  switch (fileType) {
    case ProjectFileType.Flare:
      return flare;
    case ProjectFileType.ConditionTagSet:
      return conditionSet;
    case ProjectFileType.VariableSet:
      return variableSet;
    case ProjectFileType.Target:
      return target;
    //disable-toc: case ProjectFileType.Toc:
    //disable-toc:   return toc;
  }
}

export function getSchemaByFilePath(filePath: string): CollabSchema | undefined {
  const fileType = getFileType(filePath);
  return getSchemaByFileType(fileType);
}

export function getSchemaByParams(reviewFileId?: number, filePath?: string): CollabSchema | undefined {
  if (Number.isInteger(reviewFileId)) {
    return getSchemaByName(FlareSchemaName); // only Topic files can be reviewed
  }
  if (filePath) {
    return getSchemaByFilePath(filePath);
  }
}

/** Gets the project file type by the prosemirror document schema name. */
export function getProjectFileTypeBySchemaName(schemaName: string): ProjectFileType {
  switch (schemaName) {
    case flare.name:
      return ProjectFileType.Flare;
    case conditionSet.name:
      return ProjectFileType.ConditionTagSet;
    case target.name:
      return ProjectFileType.Target;
    //disable-toc:case toc.name:
    //disable-toc:return ProjectFileType.Toc;
    case variableSet.name:
      return ProjectFileType.VariableSet;
    default:
      return undefined;
  }
}
